import { faLocationCrosshairs } from '@awesome.me/kit-5231b03bd6/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSProperties } from 'react';
import { GroupBase, OptionProps, components } from 'react-select';
import { useAppSelector } from '~/state';
import {
  selectCanUseGeolocation,
  selectLocationIsSupportedArea,
} from '~/state/location';
import { ComboBoxPrediction } from '~/utilities';

export const UseCurrentLocationOption = {
  label: 'Use my location',
  value: 'use-my-location',
  isUseCurrentLocation: true,
} as ComboBoxPrediction;

function ReactSelectOption(
  props: OptionProps<ComboBoxPrediction, false, GroupBase<ComboBoxPrediction>>
) {
  const { children, isDisabled, innerRef, innerProps, getStyles } = props;
  return (
    <div
      ref={innerRef}
      aria-disabled={isDisabled}
      style={getStyles('option', props) as CSSProperties}
      {...innerProps}
    >
      {children}
    </div>
  );
}

function CurrentLocationOption(
  props: OptionProps<ComboBoxPrediction, false, GroupBase<ComboBoxPrediction>>
) {
  const canUseGeolocation = useAppSelector(selectCanUseGeolocation);
  const isWithinSupportedArea = useAppSelector(selectLocationIsSupportedArea);
  if (!canUseGeolocation) return null;
  if (!isWithinSupportedArea) return null;

  const style = {
    backgroundColor: 'transparent',
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 12px 0px',
  };

  return (
    <components.Option {...props} getStyles={() => ({ style })}>
      <div
        role="button"
        tabIndex={0}
        className="flex items-center p-2"
        aria-label="Click to use your current location"
        data-testid="current-location-button"
        onKeyDown={(e) =>
          (e.key === 'Enter' || e.key === ' ') && props.selectOption(props.data)
        }
      >
        <FontAwesomeIcon
          icon={faLocationCrosshairs}
          className="text-brand-70"
        />
        <div className="ml-2 flex flex-col justify-center">
          <span className="text-brand-70 underline">Use my location</span>
        </div>
      </div>
    </components.Option>
  );
}

export function LocationInputOption(
  props: OptionProps<ComboBoxPrediction, false, GroupBase<ComboBoxPrediction>>
) {
  const { data } = props;

  if (data.isUseCurrentLocation) {
    return <CurrentLocationOption {...props} />;
  }
  return <ReactSelectOption {...props} />;
}
